// Custom GraphQL queries for better control over Shopify data fetching
import logger from '../utils/logger';

export const PRODUCTS_QUERY = `
  query getProducts($first: Int!, $after: String) {
    products(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          title
          handle
          description
          descriptionHtml
          availableForSale
          publishedAt
          productType
          vendor
          tags
          createdAt
          updatedAt
          options {
            id
            name
            values
          }
          images(first: 10) {
            edges {
              node {
                id
                src
                altText
              }
            }
          }
          variants(first: 100) {
            edges {
              node {
                id
                title
                availableForSale
                sku
                price {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

// Fetch all products with pagination
export async function fetchAllProducts(client: any): Promise<any[]> {
  let allProducts: any[] = [];
  let hasNextPage = true;
  let cursor = null;
  
  
  while (hasNextPage) {
    try {
      const response: any = await client.graphQLClient.send(PRODUCTS_QUERY, {
        first: 250, // Maximum allowed by Shopify
        after: cursor
      });
      
      const products = response.products.edges.map((edge: any) => {
        const node = edge.node;
        return {
          ...node,
          images: node.images.edges.map((imgEdge: any) => imgEdge.node),
          variants: node.variants.edges.map((varEdge: any) => varEdge.node)
        };
      });
      
      allProducts = [...allProducts, ...products];
      
      hasNextPage = response.products.pageInfo.hasNextPage;
      if (hasNextPage && response.products.edges.length > 0) {
        cursor = response.products.edges[response.products.edges.length - 1].cursor;
      }
      
    } catch (error) {
      logger.error('Error fetching products batch');
      hasNextPage = false;
    }
  }
  
  return allProducts;
}